
export const VIDEOS_STATE = {
  ALL: 'all',
  ACTIVE: 'active',
  DELETED: 'deleted',
};

export const MEDIA_ASSET_STATE = {
  INITIAL: 'initial',
  PROCESSING: 'processing',
  READY: 'ready',
  ERROR: 'error',
};

export const ITEMS_PER_PAGE = 25;

// Source tabs rendered above the video list. Each tab maps to the `source*`
// filterBy token it applies (null = no source filter, i.e. "All"), the key in
// the source-counts response used for its count badge, and a design-system icon
// shown before the label. `featureFlag`, when set, hides the tab unless the
// feature flag is enabled; it may be a single flag key or an array of keys. For
// an array, `featureFlagMode` controls how they combine — 'and' (the default when
// omitted) requires every flag, 'or' requires any one. Labels use dedicated tab
// keys (not the older `videosVodPageFilter.source*` filter labels, which read
// "... imports"). Instagram/TikTok are the brand's own connected content; UGC is
// rights-requested creator content and is a separate, non-overlapping bucket.
export const SOURCE_TABS = [
  { id: 'all', sourceToken: null, label: 'videosVodPageTabs.all', fallbackLabel: 'All', countKey: 'sourceAll' },
  { id: 'uploads', sourceToken: 'sourceNone', label: 'videosVodPageTabs.uploads', fallbackLabel: 'Uploads', iconName: 'upload', countKey: 'sourceNone' },
  { id: 'instagram', sourceToken: 'sourceInstagram', label: 'videosVodPageTabs.instagram', fallbackLabel: 'Instagram', iconName: 'instagramFilled', countKey: 'sourceInstagram', featureFlag: ['instagramEnabled', 'ugcV2Enabled'], featureFlagMode: 'or' },
  { id: 'tiktok', sourceToken: 'sourceTiktok', label: 'videosVodPageTabs.tiktok', fallbackLabel: 'TikTok', iconName: 'tiktok', countKey: 'sourceTiktok', featureFlag: 'ugcTikTokEnabled' },
  { id: 'ugc', sourceToken: 'sourceUgc', label: 'videosVodPageTabs.ugc', fallbackLabel: 'UGC', iconName: 'people', countKey: 'sourceUgc', featureFlag: 'ugcV2Enabled' },
  { id: 'live', sourceToken: 'sourceLive', label: 'videosVodPageTabs.live', fallbackLabel: 'Live shows', iconName: 'shows', countKey: 'sourceLive' },
  { id: 'ai', sourceToken: 'sourceAi', label: 'videosVodPageTabs.ai', fallbackLabel: 'AI', iconName: 'wand', countKey: 'sourceAi', featureFlag: 'aiImageToVideoEnabled' },
];

// filterBy tokens of the Library's products filter. Unlike the source tokens
// they are not tied to a tab, so they ride along when the tab changes.
export const PRODUCT_FILTER_TOKENS = {
  TO_REVIEW: 'productsToReview',
};

export const getProductFilterTokens = (filterBy) => (filterBy || '')
  .split(',')
  .filter((token) => Object.values(PRODUCT_FILTER_TOKENS).includes(token));

export const FIELD_DEF_NAMES = {
  TAG: 'tag',
};
